module.exports = new __parcel__URL__("people-working-on-computers.c86cef7c.svg").toString();